module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice-events/boxoffice-events.component.scss
// module id = ./src/app/routes/boxoffice/boxoffice-events/boxoffice-events.component.scss
// module chunks = 9